/**
 * Created by PuTi(编程即菩提) 7/28/17.
 */
var nb = require('../../../nb');
var image = nb.define({
    view: {
        'class': 'image',
        style: {
            'background-image': nb.bind('url')
        },
        $html: {
            $name: 'img',
            tag: 'img'
            //src: nb.bind('src')
        }
    },
    method: {
        onModelReady: function (inModel) {
            var self = this;
            function load() {
                var model = self.getModel();
                var $img = self.$('img');
                $img.off('load', load);
                model.set('ready', true);
            }
            inModel.onChange('src', function (inEvent) {
                var src = inEvent.data;
                var $img = self.$('img');
                $img.on('load', load);
                $img.attr('src', src);
            }, this);
        }
    }
});
var movieBanner = nb.define({
    // parent: nb.view.List,
    view: {
        'class': ['swiper-slide banner'],
        $html: [{
            $type:nb.view.List,
            $model:''
        },{
            'class':['slide-mask',nb.bind('maskState')],
            style: {
                'background-image': nb.bind('imgUrl')
            }
        }]
    }
});

module.exports = {
    movieBanner: movieBanner,
    image: image
};


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/MovieBanner.js
// module id = 193
// module chunks = 1